import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import createSagaMiddleware from 'redux-saga';
import { connectRouter, routerMiddleware } from 'connected-react-router';

import rootSaga from './sagas/rootSaga';
import { history } from 'utils';
import authReducer from 'slices/authSlice';
import shopListReducer from 'slices/shopSlice';
import bills from 'slices/billsSlice';
import shopSettingReducer from 'slices/shopSettingSlice';
import rankingReducer from 'slices/rankingSlice';


const rootReducer = combineReducers({
  // router: connectRouter(history),
  counter: counterReducer,
  auth: authReducer,
  shopList: shopListReducer,
  bills,
  shopSetting: shopSettingReducer,
  ranking: rankingReducer
});

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,

  // Add saga to toolkit
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),
  // getDefaultMiddleware().concat(sagaMiddleware, routerMiddleware(history)),
});

// Add root  saga
sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
